interface Flag {
	defaultValue: unknown;
}

export const flags = {
	enabledLanguages: {
		defaultValue: 'en',
	},
	isDevTeam: {
		defaultValue: false,
	},
	contractRequestStatusLive: {
		defaultValue: false,
	},
	// https://onetakeda.atlassian.net/browse/MKT-4473
	supplierRatingsLive: {
		defaultValue: false,
	},
	disableSearchAnalytics: {
		defaultValue: false,
	},
	disableAppInsightsAnalytics: {
		defaultValue: false,
	},
	globalLevelBanner: {
		defaultValue: false,
	},
	buyeasySuperusers: {
		defaultValue: false,
	},
	profileMenuItemEnabled: {
		defaultValue: false,
	},
	buyEasyContractNotifications: {
		defaultValue: false,
	},
	buyEasyTprmNotifications: {
		defaultValue: false,
	},
} satisfies Record<string, Flag>;

type Flags = typeof flags;
export type FlagName = keyof Flags;
export type FlagValue<T extends FlagName> = Flags[T]['defaultValue'];
